import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import MovieGrid from '@/components/feature/MovieGrid';
import { getLatestMovies } from '@/lib/movieData';
import type { MediaType } from '@/types/movie';

const tabs: { key: MediaType | 'all'; label: string }[] = [
  { key: 'all', label: '全部' },
  { key: 'movie', label: '电影' },
  { key: 'tv', label: '电视剧' },
  { key: 'variety', label: '综艺' },
];

export default function LatestSection() {
  const [active, setActive] = useState<MediaType | 'all'>('all');
  const list = getLatestMovies(12, active === 'all' ? undefined : active);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <SectionHeading
        eyebrow="刚刚更新"
        title="最新内容"
        description="按更新与上线时间排序，率先看到近期值得关注的新片新剧。"
        action={
          <div className="flex items-center gap-1 p-1 rounded-full bg-background-200">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setActive(t.key)}
                className={`h-8 px-4 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${active === t.key ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'}`}
              >
                {t.label}
              </button>
            ))}
          </div>
        }
      />
      <MovieGrid movies={list} columns={6} />
    </section>
  );
}